import React from 'react';
import { cn } from "@/lib/utils";

/**
 * Shared empty state for consistent UX across the app.
 * Default / compact use the same warm paper + ink palette as narrative; narrative keeps serif for longer copy.
 */
const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  className,
  variant = 'default', // 'default' | 'compact' | 'narrative'
  ...rest
}) => {
  const isCompact = variant === 'compact';
  const isNarrative = variant === 'narrative';

  return (
    <div
      className={cn(
        'text-center',
        isCompact ? 'py-8' : 'py-16 sm:py-24',
        className
      )}
      {...rest}
    >
      {Icon && (
        <div
          className={cn(
            'mx-auto mb-4 flex items-center justify-center rounded-2xl ring-1 ring-[#c9a961]/18',
            isCompact ? 'h-10 w-10' : 'h-16 w-16',
            'bg-[#c9a961]/15 text-[#8b7355]'
          )}
        >
          <Icon className={isCompact ? 'h-5 w-5' : 'h-8 w-8'} />
        </div>
      )}
      <h3
        className={cn(
          'mb-2 text-[#1c1917]',
          isNarrative && 'font-serif font-light',
          !isNarrative && 'font-medium',
          isCompact ? 'text-base' : 'text-xl'
        )}
      >
        {title}
      </h3>
      {description && (
        <p
          className={cn(
            'mx-auto max-w-sm leading-relaxed text-[#5c534a]',
            isNarrative && 'font-serif',
            isCompact ? 'mb-4 text-sm' : 'mb-8 text-base'
          )}
        >
          {description}
        </p>
      )}
      {action && <div className="flex justify-center">{action}</div>}
    </div>
  );
};

export { EmptyState };
